import useReduxSelector from './useReduxSelector';

/**
 * App-wide reference data lives in the `pageData` slice of the redux store. Each
 * key is a list (or value) that the corresponding data service loads and keeps
 * fresh over a socket on auth — see Person/Team/Company/Settings `initializeSocket()`.
 * These are the keys currently populated.
 */
export const PAGE_DATA_KEYS = {
  selectUsers: 'selectUsers',
  teams: 'teams',
  selectCompanies: 'selectCompanies',
  settings: 'settings',
  templateFiles: 'templateFiles'
};

/**
 * Reads page data from the store without `connect`. Pass a key to subscribe to a
 * single slice (re-rendering only when that slice changes); omit it to get the
 * whole pageData map.
 *
 * @param {string} [key] - one of PAGE_DATA_KEYS, e.g. 'selectUsers'.
 * @returns the value at `state.pageData[key]`, or the full pageData object.
 *
 * @example
 *   const users = usePageData(PAGE_DATA_KEYS.selectUsers);
 *   const teams = usePageData('teams');
 */
export default function usePageData(key) {
  return useReduxSelector((state) => (key == null ? state.pageData : state.pageData[key]));
}
